/**
 * [perf] counters for the navigation battery/heat investigation (Sep 29 2026).
 *
 * Logging only — nothing reads these to make a decision. NavigationView and
 * MapView increment them; NavigationView prints one `[perf]` line every 10s
 * while navigation is open, as per-second rates since the previous line:
 *
 *   raf           puck requestAnimationFrame callbacks
 *   renders       NavigationView React renders
 *   navMapRenders nav map "render" events (frames the GL map actually drew)
 *   planMapRenders planning MapView "render" events (should be ~0 under nav)
 *   pump          native location-pump fixes delivered to JS
 *   plugin        Capacitor watch fixes delivered to JS (counted even when
 *                 ignored because the pump owns the stream)
 */
export const navPerf = {
  raf: 0,
  renders: 0,
  navMapRenders: 0,
  planMapRenders: 0,
  pump: 0,
  plugin: 0,
};

export type NavPerfKey = keyof typeof navPerf;

/** Returns the formatted rates since the last call and zeroes the counters. */
export function takeNavPerfLine(elapsedMs: number): string {
  const s = Math.max(elapsedMs, 1) / 1000;
  const parts = (Object.keys(navPerf) as NavPerfKey[]).map((k) => {
    const rate = navPerf[k] / s;
    navPerf[k] = 0;
    return `${k}=${rate.toFixed(1)}/s`;
  });
  return parts.join(" ");
}
